import React from "react";

import { DataGrid } from "@material-ui/data-grid";

export default function orderHistoryTable(props) {
  return (
    <div className="orderHistoryTable">
      <DataGrid
        rows={props.rows}
        columns={props.columns}
        pageSize={5}
        checkboxSelection
      />
    </div>
  );
}
